import { isAfter, isValid, isWithinInterval, parse } from "date-fns";

import type { MultilinkStoryblok } from "@/component-types-sb";

const STORYBLOK_DATE_FORMAT = "yyyy-MM-dd HH:mm";

export const parseStoryblokDate = (value?: string, baseDate = new Date()) => {
  if (!value?.trim()) return undefined;
  const parsed = parse(value, STORYBLOK_DATE_FORMAT, baseDate);
  return isValid(parsed) ? parsed : undefined;
};

export const isWithinStoryblokSchedule = (
  publishDate?: string,
  expireDate?: string,
  today = new Date()
) => {
  const publish = parseStoryblokDate(publishDate, today);
  const expire = parseStoryblokDate(expireDate, today);

  if (!publish && !expire) return true;

  if (publish && expire) {
    if (isAfter(publish, expire)) return false; // invalid window
    return isWithinInterval(today, { start: publish, end: expire });
  }

  if (publish) return !isAfter(publish, today); // today >= publish
  if (expire) return !isAfter(today, expire); // today <= expire

  return false;
};

export function getUrlFromLinkObject(link: MultilinkStoryblok | undefined) {
  if (!link) return "";
  if (link.linktype === "story") {
    if (link.story?.full_slug) {
      return "/" + link.story.full_slug;
    } else {
      return link.cached_url;
    }
  }
  return link.url;
}
